

// // Optimized and functional OldCar component using function components with full table, date filtering, and pagination
// import React, { useState, useEffect, useMemo } from "react";
// import { Link, useParams } from "react-router-dom";
// import _ from "lodash";
// import dayjs from "dayjs";
// import "./OldCars.css"; // We'll create this CSS file

// const OldCar = ({ login, client, viewAllOldCar, deleteOldCar, updateOldCarStatus }) => {
//   const { id } = useParams();
//   const [searchInput, setSearchInput] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [selectedRange, setSelectedRange] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [view, setView] = useState(false);
//   const [reject, setReject] = useState(false);
//   const [editStatus, setEditStatus] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [oldCarId, setOldCarId] = useState("");
//   const [status, setStatus] = useState("");

//   const debouncedSearch = useMemo(() =>
//     _.debounce(() => {
//       viewAllOldCar(
//         login.token,
//         login.user_id,
//         searchInput,
//         page,
//         rowsPerPage,
//         startDate,
//         endDate,
//         selectedStatus
//       );
//     }, 300),
//     [searchInput, page, rowsPerPage, startDate, endDate, selectedStatus]
//   );

//   useEffect(() => {
//     viewAllOldCar(
//       login.token,
//       login.user_id,
//       searchInput,
//       page,
//       rowsPerPage,
//       startDate,
//       endDate,
//       selectedStatus
//     );
//   }, []);

//   useEffect(() => {
//     debouncedSearch();
//     return debouncedSearch.cancel;
//   }, [searchInput, debouncedSearch]);

//   const handleDateRangeChange = (e) => {
//     const today = dayjs().startOf("day");
//     const range = e.target.value;
//     setSelectedRange(range);
//     let start = "";
//     let end = "";

//     switch (range) {
//       case "today":
//         start = end = today.format("YYYY-MM-DD");
//         break;
//       case "yesterday":
//         start = end = today.subtract(1, "day").format("YYYY-MM-DD");
//         break;
//       case "7days":
//         start = today.subtract(6, "day").format("YYYY-MM-DD");
//         end = today.format("YYYY-MM-DD");
//         break;
//       case "thismonth":
//         start = today.startOf("month").format("YYYY-MM-DD");
//         end = today.format("YYYY-MM-DD");
//         break;
//       default:
//         start = end = "";
//     }

//     setStartDate(start);
//     setEndDate(end);
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleDelete = () => {
//     deleteOldCar(login.token, login.user_id, oldCarId, page, rowsPerPage);
//     setReject(false);
//     setOldCarId("");
//   };

//   const handleStatusSave = () => {
//     updateOldCarStatus(login.token, login.user_id, selectedEmployee._id, status, page, rowsPerPage);
//     setEditStatus(false);
//     setStatus("");
//   };

//   const allOldCars = client?.allOldCar || [];
//   const totalCount = client?.allOldCarLength || 0;

//   return (
//     <div className="oldcar-container">
//       {/* Add Button */}
//       <div className="oldcar-header">
//         <Link to="/addinfo" className="add-button">
//           <button className="btn btn-primary">
//             <span className="btn-icon">+</span>
//             Add Old Car
//           </button>
//         </Link>
//       </div>

//       {/* Filters Section */}
//       <div className="filters-section">
//         <div className="filters-grid">
//           {/* Search */}
//           <div className="filter-item">
//             <div className="search-box">
//               <span className="search-icon"></span>
//               <input
//                 type="text"
//                 placeholder="Search"
//                 value={searchInput}
//                 onChange={(e) => setSearchInput(e.target.value)}
//                 className="search-input"
//               />
//             </div>
//           </div>

//           {/* Date Filter */}
//           <div className="filter-item">
//             <select
//               value={selectedRange}
//               onChange={handleDateRangeChange}
//               className="filter-select"
//             >
//               <option value="">Date Filter</option>
//               <option value="today">Today</option>
//               <option value="yesterday">Yesterday</option>
//               <option value="7days">Last 7 Days</option>
//               <option value="thismonth">This Month</option>
//               <option value="Custom">Custom</option>
//             </select>
//           </div>

//           {/* Custom Date Range */}
//           {selectedRange === "Custom" && (
//             <>
//               <div className="filter-item">
//                 <input
//                   type="date"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   className="date-input"
//                 />
//               </div>
//               <div className="filter-item">
//                 <input
//                   type="date"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   className="date-input"
//                 />
//               </div>
//             </>
//           )}

//           {/* Status Filter */}
//           <div className="filter-item">
//             <select
//               value={selectedStatus}
//               onChange={(e) => setSelectedStatus(e.target.value)}
//               className="filter-select"
//             >
//               <option value="">All Status</option>
//               {["Sale", "Rejected", "Active"].map((s) => (
//                 <option key={s} value={s}>{s}</option>
//               ))}
//             </select>
//           </div>

//           {/* Pagination */}
//           <div className="pagination-top">
//             <div className="pagination-controls">
//               <span className="pagination-info">
//                 {totalCount > 0 ? `1-${Math.min(rowsPerPage, totalCount)} of ${totalCount}` : '0 items'}
//               </span>
//               <select
//                 value={rowsPerPage}
//                 onChange={handleChangeRowsPerPage}
//                 className="rows-select"
//               >
//                 <option value={5}>5</option>
//                 <option value={10}>10</option>
//                 <option value={25}>25</option>
//                 <option value={50}>50</option>
//                 <option value={100}>100</option>
//                 <option value={totalCount}>All</option>
//               </select>
//               <div className="page-buttons">
//                 <button
//                   onClick={() => handleChangePage(null, page - 1)}
//                   disabled={page === 0}
//                   className="page-btn"
//                 >
//                   ‹
//                 </button>
//                 <button
//                   onClick={() => handleChangePage(null, page + 1)}
//                   disabled={(page + 1) * rowsPerPage >= totalCount}
//                   className="page-btn"
//                 >
//                   ›
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table-section">
//         <div className="table-container">
//           <table className="data-table">
//             <thead>
//               <tr>
//                 {["Sl No", "Brand", "Car Name", "Car Type", "Price", "Discounted Price", "Date", "Status", "Actions"].map((h, i) => (
//                   <th key={i} className="table-header">
//                     {h}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {allOldCars?.map((item, index) => {
//                 const date = new Date(item.createdAt).toLocaleDateString();
//                 const time = new Date(item.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//                 return (
//                   <tr key={item._id} className="table-row">
//                     <td className="table-cell">{index + 1}</td>
//                     <td className="table-cell">{item.brand}</td>
//                     <td className="table-cell">{item.carName}</td>
//                     <td className="table-cell">{item.carType}</td>
//                     <td className="table-cell">{item.price}</td>
//                     <td className="table-cell">{item.discountedPrice}</td>
//                     <td className="table-cell">
//                       <div className="date-time">
//                         <div>{date}</div>
//                         <div className="time">{time}</div>
//                       </div>
//                     </td>
//                     <td className="table-cell">
//                       <div className="status-cell">
//                         <span>{item.status}</span>
//                         <button 
//                           className="icon-btn edit-btn"
//                           onClick={() => { setSelectedEmployee(item); setEditStatus(true); }}
//                           title="Edit Status"
//                         >
//                           ✏️
//                         </button>
//                       </div>
//                     </td>
//                     <td className="table-cell">
//                       <div className="action-buttons">
//                         <Link to={`/view/${item._id}`}>
//                           <button className="icon-btn view-btn" title="View">
//                             👁️
//                           </button>
//                         </Link>
//                         <button 
//                           className="icon-btn delete-btn"
//                           onClick={() => { setOldCarId(item._id); setReject(true); }}
//                           title="Delete"
//                         >
//                           🗑️
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Delete Dialog */}
//       {reject && (
//         <div className="dialog-overlay">
//           <div className="dialog">
//             <div className="dialog-header">
//               <h3>Confirm Delete</h3>
//             </div>
//             <div className="dialog-content">
//               <p>Are you sure you want to delete this old car?</p>
//             </div>
//             <div className="dialog-actions">
//               <button onClick={() => setReject(false)} className="btn btn-secondary">No</button>
//               <button onClick={handleDelete} className="btn btn-danger">Yes</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Status Edit Dialog */}
//       {editStatus && (
//         <div className="dialog-overlay">
//           <div className="dialog">
//             <div className="dialog-header">
//               <h3>Edit Old Car Status</h3>
//             </div>
//             <div className="dialog-content">
//               <select
//                 value={status}
//                 onChange={(e) => setStatus(e.target.value)}
//                 className="status-select"
//               >
//                 <option value="">Select Status</option>
//                 {["Sale", "Rejected"].map((s) => (
//                   <option key={s} value={s}>{s}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="dialog-actions">
//               <button onClick={() => setEditStatus(false)} className="btn btn-secondary">Cancel</button>
//               <button onClick={handleStatusSave} className="btn btn-primary">Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OldCar;



import React, { useEffect, useState, useCallback } from "react";
import DataTable from "../Components/Common/DataTable";
import SearchBox from "../Components/Common/SearchBox";
import DateRangeFilter from "../Components/Common/DateRangeFilter";
import DeleteButton from "../Components/Common/DeleteButton";
import ViewButton from "./Common/ViewButton";
import { Link } from "react-router-dom";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";

const statusColors = {
  Requested: "#6366f1",       // Indigo
  Pending: "#f59e0b",         // Amber
  "In Progress": "#3b82f6",   // Blue
  Resolved: "#22c55e",        // Green
  Closed: "#6b7280",          // Gray
};


export default function OldCars({
  login,
  client,
  viewAllOldCar,
  deleteOldCar,
  updateOldCarStatus,
  snackbar, close_snack_bar

}) {
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [editingStatusId, setEditingStatusId] = useState(null);

  const fetchData = useCallback(() => {
    viewAllOldCar(
      login.token,
      login.user_id,
      searchInput,
      page,
      rowsPerPage,
      startDate,
      endDate,
      selectedStatus
    );
  }, [login, searchInput, page, rowsPerPage, startDate, endDate, selectedStatus, viewAllOldCar]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [searchInput, fetchData]);

  // Reload on page/rows/date/status change
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, startDate, endDate, selectedStatus, fetchData]);

  const oldcars = client?.allOldCar || [];
  const oldcarsCount = client?.allOldCarLength || 0;
  const pageLength = client?.oldcars_length || 0;
  const columns = [
    {
      header: "Car Name",
      key: "carName",
    },
    { header: "Brand", key: "brand" },
    { header: "Price", key: "price" },
    { header: "Discounted Price", key: "discountedPrice" },
    {
      header: "Created Date",
      key: "createdAt",
      render: (row) => {
        const date = new Date(row.createdAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },

    {
      header: "Last Updated",
      key: "updatedAt",
      render: (row) => {
        const date = new Date(row.updatedAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },
    {
      header: "Status",
      key: "status",
      render: (row) => {
        const isEditing = editingStatusId === row._id;

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {isEditing ? (
              <select
                autoFocus
                defaultValue={row.status}
                onChange={(e) => {
                  const newStatus = e.target.value;

                  updateOldCarStatus(
                    login.token,
                    login.user_id,
                    row._id,
                    newStatus,
                    page,
                    rowsPerPage
                  );

                  setEditingStatusId(null);
                }}
                onBlur={() => setEditingStatusId(null)} // Close if mouse clicked outside
                style={{
                  padding: "4px 6px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">Chooes Status</option>
                <option>Sold</option>
                <option>Avilable</option>
                {/* <option>In Progress</option>
                <option>Resolved</option>
                <option>Closed</option>  */}
              </select>
            ) : (
              <span
                onClick={() => setEditingStatusId(row._id)}
                style={{
                  padding: "4px 10px",
                  borderRadius: "6px",
                  color: "white",
                  backgroundColor: statusColors[row.status] || "#6b7280",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                {row.status}
              </span>
            )}
          </div>
        );
      },
    },

    {
      header: "Action",
      key: "action",
      render: (row) => (
        <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
          <ViewButton
            data={row}
            buttonLabel="View"
            redirectTo={(d) => `/view/${d._id}`}
          />


          <DeleteButton
            item={row}
            viewName="Contact"
            onDelete={(oldcars) => deleteOldCar(login.token, login.user_id, oldcars._id, page,
              rowsPerPage)}
          />
        </div>
      ),
    },
  ];

  return (
    <div style={{ padding: "15px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            fontSize: "22px",
            margin: 0,
            fontWeight: "600",
          }}
        >
          Old Cars ({oldcarsCount})
        </h2>

        <Link to="/addinfo" style={{ textDecoration: "none" }}>
          <button
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 18px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#145ea8")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#1976d2")}
          >
            <span
              style={{
                fontSize: "18px",
                fontWeight: "600",
                lineHeight: "14px",
              }}
            >
              +
            </span>
            Add Old Car
          </button>
        </Link>
      </div>



      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        {/* Search box */}
        <SearchBox value={searchInput} onChange={setSearchInput} />

        {/* Filters: Status + Date */}
        <div style={{ display: "flex", gap: "8px" }}>
          <select
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value);
            }}
          >
            <option value="">All</option>
            <option>Avilable</option>
            <option>Sold</option>
          </select>

          <DateRangeFilter
            onDateChange={({ start, end }) => {
              setStartDate(start);
              setEndDate(end);
            }}
          />
        </div>
      </div>
      {/* {console.log(totalCount)} */}
      {/* Table */}
      <DataTable
        columns={columns}
        data={oldcars}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPage={pageLength}
        onPageChange={(p) => setPage(p)}
      />

      <LoaderCon />
      {/* <Snackbar1
        open={snackbar.response_received}
        onClose={close_snack_bar}
        message={snackbar.message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      /> */}
    </div>
  );
}



